import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { registerLicense } from '@syncfusion/ej2-base'
import { env } from 'common/utils/env'
import App from './App'
import { Scripts } from './Scripts'
import { installBvhRaycastPatch } from 'features/Procedure/procedure-model/lib/bvh-setup'

installBvhRaycastPatch()

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
registerLicense(env.SYNCFUSION_KEY)

window.React = React

root.render(
  <StrictMode>
    <Scripts />
    <App />
  </StrictMode>,
)
